import * as React from 'react'
import './carrot-up.css'

export const CarrotUp = (props: any) =>
<svg xmlns="http://www.w3.org/2000/svg" width={props.svgwidth || 13.656} height={props.svgheight || 7.52} viewBox="0 0 13.656 7.52">
    <path id="Chevron_Right" d="M.2 6.341L6.341.2a.69.69 0 0 1 .976.974L1.663 6.828l5.654 5.652a.69.69 0 0 1-.976.975L.2 7.316a.7.7 0 0 1 0-.975z" className={props.black ? 'carrot-up-black' : 'carrot-up-white'} transform="rotate(90 6.828 6.828)"/>
</svg>
